<template>
	<a
		href="#"
		@click.prevent="activeModule(module)"
		class="module-card-wrapper"
	>
		<div class="module-card" :class="module.color_scheme">
			<div
				class="module-card-body"
				:style="'background-image: url(' + module.image + ');'"
			>
				<div class="module-card-body-content">
					<h4 class="module-card-title">{{ module.name }}</h4>
					<div
						class="module-card-description"
						v-if="module.short_description"
						v-html="module.short_description"
					></div>
				</div>
			</div>
			<div class="module-card-bottom">
				<p>
					Gå till modul
					<Icon
						class="margin-left-xs-1 icon-17"
						:icon="'arrow-thin-right'"
					/>
				</p>
			</div>
		</div>
	</a>
</template>
<script>
import Icon from "./../partials/Icon.vue";
export default {
	name: "ModuleCard",
	props: ["module"],
	components: { Icon },
	computed: {},
	methods: {
		activeModule(module) {
			this.$store.commit("activeModule", module);
			this.$store.dispatch("scrollToAppTop");
		}
	},
	mounted() {}
};
</script>